package com.exura.features.demofeatures.domain.model

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("CheckFeatureEnabledRequest")
data class CheckFeatureEnabledRequest(
    @JsName("featureId")
    val featureId: String
)
